import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EducationChart from '../../EducationChart/EducationChartContainer';

class EducationGoalChartView extends Component {
  componentDidUpdate(prevProps) {
    const { clientId, fpId, goalId, initialChartData, fetchData } = this.props;
    const prevInitialChartData = prevProps.initialChartData;
    const prevFpId = prevProps.fpId;

    if (prevInitialChartData !== initialChartData) {
      if (!initialChartData) {
        fetchData(clientId, fpId, goalId);
      }
    } else if (fpId !== prevFpId) {
      fetchData(clientId, fpId, goalId);
    }
  }

  render() {
    const { clientId, fpId, goalId, initialChartData, title } = this.props;
    return (
      <div className="carousel-education-chart-container">
        <h4>{title}</h4>
        <EducationChart
          clientId={clientId}
          fpId={fpId}
          goalId={goalId}
          data={initialChartData}
          showTitle={false}
          showLabel={false}
        />
      </div>
    );
  }
}

EducationGoalChartView.defaultProps = {
  initialChartData: null,
};

EducationGoalChartView.propTypes = {
  clientId: PropTypes.string.isRequired,
  fpId: PropTypes.string.isRequired,
  initialChartData: PropTypes.shape({}),
  goalId: PropTypes.string.isRequired,
  setData: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default EducationGoalChartView;
